import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../constants/api";
import { baseUrl } from "../constants/url";

const NotificationHistory = () => {
  
  const [ loading, setLoading ] = useState(false)
  const [ error, setError ] = useState('')
  const [ page, setPage ] = useState(1)
  const [ itemsPerPage, setItemsPerPage ] = useState(10)
  const [ data, setData ] = useState([])
  const [ noMoreData, setNoMoreData ] = useState(false)
  const [memberInfo, setMemberInfo] = useState<any>({})
  const [memberLoading, setMemberLoading] = useState(false)

  async function getNotificationData() {
    if(page > 0 && itemsPerPage > 0) {
      try {
        setLoading(true)
        setError('')
        const response = await api(true, `/admin/notification-history?page=${page}&limit=${itemsPerPage}`, 'get')
        setLoading(false)
        if(Array.isArray(response.data.data) && response.data.data.length <= 0) {
          setNoMoreData(true)
          if(page > 1) {
            setPage(page - 1)
          }
          return 
        }

        if(Array.isArray(response.data.data) && response.data.data.length < itemsPerPage) {
          setNoMoreData(true)
        }
        setData(response.data.data)
      } catch(error:any) {
        console.log(error)
        setLoading(false)
        setError(error?.response?.data?.message || error.message)
        setData([])
      }
    }
  }

  const handlePrev = () => {
    if(page > 1) {
      setNoMoreData(false)
      setPage(page - 1)
    }
  }

  const handleNext = () => {
    if(!noMoreData) {
      setPage(page + 1)
    }
  }

  useEffect(() => {
    getNotificationData()
  }, [page])

  const getMemberInfo = async () => {
    try {
      setMemberLoading(true)
      let localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
      const res = await api(true, `/admin/get-all-members`, 'get', {}, { authorization: `Bearer ${localuser.token}` })
      const data:any = {}
      for(let member of (res?.data?.data?.result || [])) {
        data[member.idNumber] = member
      }
      setMemberInfo(data)
    } catch(error) {
      console.log(error, ' <== Error while fetching member info')
    } finally{
      setMemberLoading(false)
    }
  }

  useEffect(() => {
    // if (localStorage.getItem('lastAuthTimeMillis') &&
    // // @ts-ignore
    // parseInt(localStorage.getItem('lastAuthTimeMillis')) > (new Date().getTime()) - 30*60*1000) {
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberCode'] = localStorage.getItem('MemberCode');
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberId'] = localStorage.getItem('MemberId');
    //    // @ts-ignore
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('Authorization');
    // } else {
    //   window.location.href = '/';
    // }
    getMemberInfo();
  }, []);

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">NOTIFICATION HISTORY</h2>
      {error && (
        <p style={{ color: 'red' }}>{error}</p>
      )}
      <div className="table-responsive">
      <table className="tbl styled-table" border={1}>
        <thead>
          <tr>
            <th style={{ minWidth: 100 }}>
              Type
            </th>
            <th>
              User
            </th>
            <th style={{ minWidth: 200 }}>
              Title
            </th>
            <th style={{ minWidth: 200 }}>
              Content
            </th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={4}>
                Loading...
              </td>
            </tr>
          )}
          {!loading && (
            data.sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()).map((item:any, index:number) => (
              <tr key={index}>
                <td>
                  {item.type}
                </td>
                <td>
                  {memberLoading ? 'Loading..' : (memberInfo[item.userId]?.memberName || item.userId)}
                </td>
                <td>
                  {item.title}
                </td>
                <td className="notification-content">
                  {item.content}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
      <div className="page-buttons-container">
        <button disabled={page === 1} onClick={handlePrev} style={{width: 50, padding: 4}}>Prev</button> 
        <button disabled={noMoreData} onClick={handleNext} style={{width: 50, padding: 4}}>Next</button>
      </div>
    </div>
  );
};

export default NotificationHistory;
